import _ from 'lodash';

import {
  useCallback,
  useMemo
} from 'react';
import {
  ImportInventoryItemInput,
  useImportInventoryItemsMutation
} from 'generated/graphql';

import { ImportCsvModal } from 'iron-forge-react-modules';
import * as types from './types';



export type IColumnDef = ImportCsvModal.IColumnDescription<types.InventoryItemsPropertyName>;



export const columnDefs: IColumnDef[] = [
  {
    id: 'Name',
    label: 'Name',
    isRequired: true,
    formatType: undefined
  },
  {
    id: 'Display Name',
    label: 'Display Name',
    isRequired: false,
    formatType: undefined
  },
  {
    id: 'Description',
    label: 'Description',
    isRequired: false,
    formatType: undefined
  },
  {
    id: 'Internal ID',
    label: 'Internal ID',
    isRequired: true,
    formatType: undefined
  },
  {
    id: 'Device Type',
    label: 'Device Type',
    isRequired: false,
    formatType: undefined
  }
];



export function useImportInventoryItemsFromCsv() {
  const [fnMutate, tuple] = useImportInventoryItemsMutation({
    refetchQueries: []
  });

  const fnWrappedMutate = useCallback(
    (rows: Array<_.Dictionary<string>>) => {
      const input = __formatTransform(rows);

      fnMutate({
        variables: {
          input
        }
      });
    },
    [fnMutate]
  );

  return useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}



function __formatTransform(rawCsvRows: Array<_.Dictionary<string>>): ImportInventoryItemInput[] {
  const rowsAsPropertyName2Value: ImportInventoryItemInput[] = _.map(rawCsvRows, row => {
    return {
      sku: row['Name'],
      name: row['Display Name'],
      description: row['Description'],
      netSuiteInternalId: row['Internal ID'],
      deviceType: row['Device Type'] ?? ''
    };
  });

  return rowsAsPropertyName2Value;
}
